import 'regenerator-runtime/runtime';
import { put, call, takeEvery, all, takeLatest } from 'redux-saga/effects';
import {
  requestLogin,
  getCurrentUser,
  getUserByClientIdAndEmail,
  sendRequestForgotPassword,
  sso,
  verifyTokenActiveUser,
  verifyTokenConfirmEmail,
  verifyTokenResetPassword,
  getIzendaToken,
  logout,
  getHOBranding,
  // externalUserAuth
  externalUserAuth
} from './api';
import * as authAction from './constants';
import { sendAjaxRequest } from 'helper/interceptors';
import * as UserActionType from 'User/constants';
import * as NotifyActionType from '../Notification/constants';
import { ObjToParam } from '../helper/helper-api';
import { AppSettings } from '../constants';

export function* requestLoginAsync(action) {
  const result = yield call(requestLogin, action.payload.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    const currentUser = yield call(getCurrentUser, result.data.access_token);
    if (currentUser.statusCode === 200) {
      const data = currentUser.data;
      const profile = Object.assign({}, result.data, data); //{...result.data, data};
      yield [
        put({
          type: authAction.REQUEST_LOGIN_SUCCESS,
          data: {
            data: profile //result.data
          }
        }),
        put({
          type: UserActionType.GET_USER_BY_USERID_SUCCESS,
          data
        })
      ];
      if (action.payload.callback) {
        action.payload.callback(profile, true);
      }
    } else {
      yield put({
        type: authAction.REQUEST_LOGIN_ERROR,
        data: { error: { Summary: [currentUser.data] } }
      });
    }
  } else {
    yield put({
      type: authAction.REQUEST_LOGIN_ERROR,
      data: { error: result.data }
    });
  }
}
export function* getIzendaTokenAsync() {
  const result = yield call(getIzendaToken);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    localStorage.setItem('izendaToken', result.data.data);
  } else {
    if (process.env.REACT_APP_ENV !== 'fe-build') {
      yield put({
        type: authAction.REQUEST_LOGIN_ERROR,
        data: { error: result.data }
      });
    }
  }
}

export function* activeUserAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    '/oauth/active-user',
    action.payload.params,
    'POST'
  );
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: authAction.ACTIVE_USER_SUCCESS,
      data: {
        data: result.data
      }
    });

    if (action.payload.callback) {
      action.payload.callback(result.data);
    }
  } else {
    yield put({
      type: authAction.ACTIVE_USER_FAILED,
      data: { error: result.data }
    });
  }
}

export function* activeExistUserAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    '/oauth/user-existing',
    action.payload,
    'POST'
  );
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    // yield put({
    //   type: authAction.ACTIVE_USER_SUCCESS,
    //   data: {
    //     data: result.data
    //   }
    // });
    if (action.callback) {
      action.callback(true);
    }
  } else {
    yield put({
      type: authAction.ACTIVE_USER_FAILED,
      data: { error: { Summary: result.data } }
    });
  }
}

export function* confirmEmailAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    '/oauth/confirm-email',
    action.payload,
    'POST'
  );
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: authAction.CONFIRM_EMAIL_SUCCESS,
      data: {
        data: result.data
      }
    });
  } else {
    yield put({
      type: authAction.CONFIRM_EMAIL_FAILED,
      data: { error: result.data }
    });
  }
}

export function* resetPasswordAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    '/oauth/reset-password',
    action.payload,
    'POST'
  );
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: authAction.RESET_PASSWORD_SUCCESS,
      data: {
        data: result.data
      }
    });
  } else {
    yield put({
      type: authAction.RESET_PASSWORD_FAILED,
      data: { error: result.data }
    });
  }
}

export function* oauthSSO(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.SITE_ONE_SERVICE_URI,
    'oauth/sso',
    action.payload,
    'POST'
  );
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [put({ type: authAction.OAUTH_SSO_SUCCESS, data: result.data })];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* selectListBuilderUserAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    // /select-lists/users
    `api/reports/user-select-list?${ObjToParam(action.params)}`,
    action.payload,
    'GET',
    false
  );
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: authAction.SELECT_LIST_BUILDER_USER_SUCCESS,
        data: result.data
      })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* selectListsBuilderUserAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    `/select-lists/users?${ObjToParam(action.params)}`, action.payload, 'GET', false
  );
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: authAction.SELECT_LISTS_BUILDER_USER_SUCCESS,
        data: result.data
      })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* selectListAdminAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    '/oauth/users-select-list-with-role-admin-super-admin',
    action.params,
    'GET',
    false
  );
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    if (action.callback) {
      action.callback();
    }
    yield [
      put({
        type: authAction.SELECT_LIST_ADMIN_SUPER_ADMIN_SUCCESS,
        data: result.data
      })
    ];
  } else {
    if (action.callback) {
      action.callback();
    }
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getCurrentUserAsync(action) {
  const currentUser = yield call(getCurrentUser, action.params);
  if (currentUser.statusCode === 200) {
    const { data } = currentUser;
    yield [
      put({
        type: authAction.GET_CURRENT_USER_SUCCESS,
        data: {
          data: data
        }
      }),
      put({
        type: UserActionType.GET_USER_BY_USERID_SUCCESS,
        data
      })
    ];
    if (action.callback) {
      action.callback(true,currentUser.data);
    }
  } else {
    if (action.callback) {
      action.callback(currentUser.data, false);
    }
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: currentUser.data });
  }
}
export function* getHOBrandingLogoColor(action) {
  const result = yield call(getHOBranding, action.params);
  if (result.statusCode === 200) {
    const { data } = result;
    yield [
      put({
        type: authAction.SET_HO_BRANDING_LOGO_COLOR_SUCCESS,
        data: {
          data: data
        }
      })
    ];
    if (action.callback) {
      action.callback(data);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}
// export function* refreshTokenAsync(action) {
//   const result = yield call(sendAjaxRequest, AppSettings.CURRENT_SITE_URI, `/oauth/refresh-token/${action.payload.refreshToken}`, null, 'GET');
//   const statusCode = result.statusCode;
//   if (statusCode === 200) {
//     const currentUser = yield call(getCurrentUser, result.data.access_token);
//     if (currentUser.statusCode === 200) {
//       const data = currentUser.data;
//       const profile = Object.assign({}, result.data, data);//{...result.data, data};
//       yield [
//         put({
//           type: authAction.REQUEST_LOGIN_SUCCESS,
//           data: {
//             data: profile//result.data
//           }
//         }),
//         put({
//           type: UserActionType.GET_USER_BY_USERID_SUCCESS,
//           data
//         })
//       ];
//       if (action.payload.callback) {action.payload.callback(profile, true);}
//     } else {
//       if (action.payload.callback) {action.payload.callback(profile, false);}
//     }
//   } else {
//     yield put({ type: authAction.REFRESH_TOKEN_ERROR, data: { error: 'refresh_error'} });
//     if (action.payload.callback) {action.payload.callback({}, false);}
//   }
// }

export function* getUserByClientIdAndEmailAsync(action) {
  const result = yield call(getUserByClientIdAndEmail, action.params);
  if (result.statusCode === 200) {
    if (action.callback) {
      action.callback(result.data, true);
    }
  } else {
    if (action.callback) {
      action.callback(
        'This email address does not belong to any account.',
        false
      );
    }
    // yield put({ type: NotifyActionType.NOTIFY_ERROR, data: 'This email address does not belong to any account.' });
  }
}

export function* requestSendForgotPasswordAsync(action) {
  const result = yield call(sendRequestForgotPassword, action.params);
  if (result.statusCode === 200) {
    yield put({
      type: NotifyActionType.ROOT_NOTIFY_SUCCESS,
      data: 'Request sent'
    });
    if (action.callback) {
      action.callback(result.data, true);
    }
  } else {
    // yield put({ type: NotifyActionType.ROOT_NOTIFY_ERROR, data: result.data });
    if (action.callback) {
      action.callback(result.data[0], false);
    }
  }
}

export function* ssoAsync(action) {
  const result = yield call(sso, action.payload.params);
  if (result.statusCode === 200) {
    const currentUser = yield call(getCurrentUser, result.data.access_token);
    if (currentUser.statusCode === 200) {
      const data = currentUser.data;
      const profile = Object.assign({}, result.data, data); //{...result.data, data};
      yield [
        put({
          type: authAction.REQUEST_LOGIN_SUCCESS,
          data: {
            data: profile //result.data
          }
        }),
        put({
          type: UserActionType.GET_USER_BY_USERID_SUCCESS,
          data
        })
      ];
      if (action.payload.callback) {
        action.payload.callback(profile, true);
      }
    } else {
      yield put({
        type: authAction.REQUEST_LOGIN_ERROR,
        data: { error: { Summary: [currentUser.data] } }
      });
    }
  } else {
    yield put({ type: NotifyActionType.ROOT_NOTIFY_ERROR, data: result.data });
  }
}

export function* verifyTokenActiveUserAsync(action) {
  const result = yield call(verifyTokenActiveUser, action.payload.params);
  if (result.statusCode === 200) {
    action.payload.callback(result.data);
  } else {
    yield put({ type: NotifyActionType.ROOT_NOTIFY_ERROR, data: result.data });
  }
}

export function* verifyTokenConfirmEmailAsync(action) {
  const result = yield call(verifyTokenConfirmEmail, action.payload.params);
  if (result.statusCode === 200) {
    action.payload.callback(result.data);
  } else {
    yield put({ type: NotifyActionType.ROOT_NOTIFY_ERROR, data: result.data });
  }
}

export function* verifyTokenResetPasswordAsync(action) {
  const result = yield call(verifyTokenResetPassword, action.payload.params);
  if (result.statusCode === 200) {
    action.payload.callback(result.data);
  } else {
    yield put({ type: NotifyActionType.ROOT_NOTIFY_ERROR, data: result.data });
  }
}

export function* logoutAsync(action) {
  const result = yield call(logout);
  if (action.callback) {
    action.callback(result.data);
  }
}
export function* externalUserAuthAsync(action) {
  const result = yield call(externalUserAuth, action.payload.params);
  if (result.statusCode === 200) {
    action.payload.callback(result.data);
  } else {
    console.log('External SSO user',result.data)
    action.payload.error(result.data);
    // yield put({ type: authAction.NOTIFY_ERROR, data: { error: 'refresh_error'} });
}
}

export default function* WatchAuth() {
  yield all([
    takeEvery(authAction.REQUEST_LOGIN_ASYNC, requestLoginAsync),
    takeEvery(authAction.ACTIVE_USER, activeUserAsync),
    takeEvery(authAction.CONFIRM_EMAIL, confirmEmailAsync),
    takeEvery(authAction.RESET_PASSWORD, resetPasswordAsync),
    takeEvery(authAction.OAUTH_SSO, oauthSSO),
    takeLatest(
      authAction.SELECT_LIST_BUILDER_USER_ASYNC,
      selectListBuilderUserAsync
    ),
    takeLatest(
      authAction.SELECT_LISTS_BUILDER_USER_ASYNC,
      selectListsBuilderUserAsync
    ),
    takeLatest(
      authAction.SELECT_LIST_ADMIN_SUPER_ADMIN_ASYNC,
      selectListAdminAsync
    ),
    takeLatest(authAction.GET_CURRENT_USER_ASYNC, getCurrentUserAsync),
    takeLatest(authAction.ACTIVE_EXIST_USER_ASYNC, activeExistUserAsync),
    takeLatest(
      authAction.GET_USER_BY_CLIENT_ID_AND_EMAIL_ASYNC,
      getUserByClientIdAndEmailAsync
    ),
    takeLatest(
      authAction.SEND_REQUEST_FORGOT_PASSWORD_ASYNC,
      requestSendForgotPasswordAsync
    ),
    takeLatest(authAction.SSO_ASYNC, ssoAsync),
    takeLatest(
      authAction.VERIFY_TOKEN_ACTIVE_USER_ASYNC,
      verifyTokenActiveUserAsync
    ),
    takeLatest(
      authAction.VERIFY_TOKEN_CONFIRM_EMAIL_ASYNC,
      verifyTokenConfirmEmailAsync
    ),
    takeLatest(
      authAction.VERIFY_TOKEN_RESET_PASSWORD_ASYNC,
      verifyTokenResetPasswordAsync
    ),
    takeLatest(authAction.GET_IZENDA_TOKEN_ASYNC, getIzendaTokenAsync),
    takeLatest(authAction.LOGOUT, logoutAsync),
    takeLatest(authAction.SET_HO_BRANDING_LOGO_COLOR, getHOBrandingLogoColor),
    // takeLatest(authAction.GET_EXTRANAL_USER_AUTH_TOKEN_ASYNC, externalUserAuthAsync)
    takeLatest(authAction.GET_EXTRANAL_USER_AUTH_TOKEN_ASYNC, externalUserAuthAsync)
    // takeEvery(authAction.REFRESH_TOKEN_ASYNC, refreshTokenAsync)
  ]);
}



// WEBPACK FOOTER //
// ./src/Auth/saga.js